module.exports = __webpack_public_path__ + "img/32.0d3a0ee9.png";